<div #dialog></div>

<div>
  <button mat-button mat-dialog-close style="float: right">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content style="clear: both">
  <mat-stepper style="height: 100%; width: 100%;" linear #ModIncStepper>
    <mat-step [completed]="validateStep1(false)">
      <form>
        <ng-template matStepLabel>What Type of Incident?</ng-template>

        <mat-grid-list cols="3" rowHeight="100px">

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;" >
              <mat-label>State *</mat-label>
              <mat-select [(value)]="data.Inc_State" (focusout)="updateAgencyList()">
                <mat-option *ngFor="let ddlItem of ddls.states" [value]="ddlItem.abbreviation">
                  {{ddlItem.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>Incident Type *</mat-label>
              <mat-select [(value)]="tempIncidents" multiple>
                <mat-option (onSelectionChange)="selectIncidentChange($event)" *ngFor="let ddlItem of ddls.incTypes" [value]="ddlItem.DDL_Desc"  [matTooltip]="ddlItem.DDL_Hover">
                  {{ddlItem.DDL_Desc}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>Case Event Type</mat-label>
              <mat-select [(value)]="tempCaseEvent" multiple>
                <mat-option (onSelectionChange)="selectCaseEventChange($event)" *ngFor="let ddlItem of ddls.RelatedArea" [value]="ddlItem.DDL_Desc"  [matTooltip]="ddlItem.DDL_Hover">
                  {{ddlItem.DDL_Desc}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>

        </mat-grid-list>

        <div>
          <button mat-button matStepperNext [disabled]="!validateStep1(false)">Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [completed]="validateNJPOPStep()" *ngIf="isNJPOPMandatory()">
      <form>
        <ng-template matStepLabel >Import NJPOP</ng-template>

        <mat-grid-list cols="5" rowHeight="100px">

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>From Date: *</mat-label>
              <input matInput [matDatepicker]="njpopFromDate"  [(ngModel)]="njpopQuery.fromDate" name="NJPOPQ_fromDate">
              <mat-datepicker-toggle matSuffix [for]="njpopFromDate"></mat-datepicker-toggle>
              <mat-datepicker #njpopFromDate></mat-datepicker>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>To Date:</mat-label>
              <input matInput [matDatepicker]="njpopToDate" [(ngModel)]="njpopQuery.toDate" name="NJPOPQ_toDate">
              <mat-datepicker-toggle matSuffix [for]="njpopToDate"></mat-datepicker-toggle>
              <mat-datepicker #njpopToDate></mat-datepicker>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>County</mat-label>
              <mat-select [(value)]="njpopQuery.county" (focusout)="updateNJPOPCity()">
                <mat-option *ngFor="let c of njpopCounties" [value]="c.County">
                  {{c.County}}
                </mat-option>
              </mat-select>
              <button mat-button mat-icon-button matSuffix (click)="clearNJPOPSearchParam_County()" *ngIf="njpopQuery.county">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>

          <!--<mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>County</mat-label>
              <input type="text" matInput [(ngModel)]="njpopQuery.county"  [matAutocomplete]="njpopCountyAutoComplete" name="njpopCountyAutoComplete" [formControl]="CNTRL_NJPOP_COUNTY">
              <mat-autocomplete #njpopCountyAutoComplete="matAutocomplete" autoActiveFirstOption (optionSelected)="updateNJPOPCity()">
                <mat-option *ngFor="let c of FLTR_NJPOP_COUNTY | async" [value]="c.County">
                  {{c.County}}
                </mat-option>
              </mat-autocomplete>
              <button mat-button mat-icon-button matSuffix (click)="clearNJPOPSearchParam_County()" *ngIf="njpopQuery.county">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>-->

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>City</mat-label>
              <mat-select [(value)]="njpopQuery.city">
                <mat-option *ngFor="let c of njpopCities" [value]="c.City">
                  {{c.City}}
                </mat-option>
              </mat-select>
              <button mat-button mat-icon-button matSuffix (click)="clearNJPOPSearchParam_City()" *ngIf="njpopQuery.city">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>

          <!--<mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>City</mat-label>
                <input type="text" matInput [(ngModel)]="njpopQuery.city" [matAutocomplete]="njpopCityAutoComplete" name="njpopCityAutoComplete" [formControl]="CNTRL_NJPOP_CITY">
                <mat-autocomplete #njpopCityAutoComplete="matAutocomplete" autoActiveFirstOption>
                <mat-option *ngFor="let c of FLTR_NJPOP_CITY | async" [value]="c.City">
                  {{c.City}}
                </mat-option>
                </mat-autocomplete>

              <button mat-button mat-icon-button matSuffix (click)="clearNJPOPSearchParam_City()" *ngIf="njpopQuery.city">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>-->

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <button mat-button color="primary" (click)="submitNJPOPSearch()"><mat-icon>search</mat-icon>&nbsp;Search NJPOP</button>
          </mat-grid-tile>

        </mat-grid-list>

        <div style="font-size:10pt; text-align:center; color:blue; margin:10px;" *ngIf="data.NJPopNo">
          <span style="border-radius: 10px; border: 2px solid blue;padding: 10px;"> NJPOP #{{data.NJPopNo}} is linked to this Incident Record</span>
        </div>

        <table style="margin:0; width: 100%;" *ngIf="njpopQueryResult.length>0">
          <thead>
          <tr>
            <td></td>
            <td>NJPOP #</td>
            <td>Type</td>
            <td>Agency (Local)</td>
            <td>Case #</td>
            <td>City</td>
            <td>County</td>
            <td>Location</td>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let njpop of njpopQueryResult">
            <td>
              <button mat-stroked-button (click)="importNJPOP(njpop)"><mat-icon>add</mat-icon>CLICK TO IMPORT</button>
              <button mat-stroked-button (click)="this.downloadService.DownloadNJPOPReport(njpop.incidentRecord.IncidentNum)"><mat-icon>visibility</mat-icon> VIEW</button>
            </td>
            <td>{{njpop.incidentRecord.IncidentNum}}</td>
            <td>{{njpop.incidentRecord.Inc_TYPE}}</td>
            <td>{{njpop.ReportingParty[0].LocalAgencyName}}</td>
            <td>{{njpop.ReportingParty[0].CaseNum}}</td>
            <td>{{njpop.incidentRecord.Inc_City}}</td>
            <td>{{njpop.incidentRecord.County}}</td>
            <td>{{njpop.incidentRecord.Inc_StreetNumber}} {{njpop.incidentRecord.Inc_StreetName}} {{njpop.incidentRecord.Inc_StreetType}}</td>
          </tr>
          </tbody>
        </table>

        <mat-grid-list cols="5" rowHeight="100px" *ngIf="showNJPOPDenyReason && (data.NJPopNo==null || data.NJPopNo=='')">
          <mat-grid-tile [colspan]="2" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>Why did you not select a NJPOP?</mat-label>
              <mat-select [(ngModel)]="tempNJPOPRejectReason" (focusout)="updateNJPOPSelectedFlag()" multiple [ngModelOptions]="{standalone: true}">
                <mat-option value="No Matching Occurrence Date Found in NJPop Results">No Matching Occurrence Date Found in NJPop Results</mat-option>
                <mat-option value="No Matching Case Number Found in NJPop Results">No Matching Case Number Found in NJPop Results</mat-option>
                <mat-option value="No Matching Agency Found in NJPop Results">No Matching Agency Found in NJPop Results</mat-option>
                <mat-option value="No Matching Location Found in NJPop Results">No Matching Location Found in NJPop Results</mat-option>
              </mat-select>

              <button mat-button mat-icon-button matSuffix (click)="clearNJPOPSearchParam_Reason()" *ngIf="data.NJPOPRejectReason">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>
        </mat-grid-list>

        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext [disabled]="!validateNJPOPStep()">Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [completed]=" (validateNJPOPStep() && validateStep3(false))">
      <form>
        <ng-template matStepLabel >Incident Details</ng-template>

        <mat-grid-list cols="4" rowHeight="100px">

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;" disabled="true">
              <mat-label>State *</mat-label>
              <mat-select [(value)]="data.Inc_State" (focusout)="updateCountyList()" disabled>
                <mat-option *ngFor="let ddlItem of ddls.states" [value]="ddlItem.abbreviation">
                  {{ddlItem.name}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Agency *</mat-label>

              <input type="text" matInput [(ngModel)]="data.Dept" [matAutocomplete]="nibinIncidentAgencyAutoComplete" name="nibinIncidentAgencyAutoComplete" [formControl]="CNTRL_INC_AGENCY">
              <mat-autocomplete #nibinIncidentAgencyAutoComplete="matAutocomplete" autoActiveFirstOption (optionSelected)="updateIncidentORI($event)" >
                <mat-option *ngFor="let c of  FLTR_INC_AGENCY | async" [value]="c.DeptName" [matTooltip]="c.DeptName + (c.County? ' ('+c.County+')' : '')">
                  {{c.DeptName}} <ng-container *ngIf="c.County">({{c.County}})</ng-container>
                </mat-option>
              </mat-autocomplete>

              <button mat-button mat-icon-button matSuffix (click)="clearIncidentAgency()" *ngIf="data.Dept">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>County *</mat-label>

              <input type="text" matInput [(ngModel)]="data.County" [matAutocomplete]="nibinIncidentCountyAutoComplete" name="nibinIncidentCountyAutoComplete" [formControl]="CNTRL_INC_COUNTY">
              <mat-autocomplete #nibinIncidentCountyAutoComplete="matAutocomplete" autoActiveFirstOption (optionSelected)="updateCityAgencyList()">
                <mat-option *ngFor="let c of FLTR_INC_COUNTY | async" [value]="c.County">
                  {{c.County}}
                </mat-option>
              </mat-autocomplete>

              <button mat-button mat-icon-button matSuffix (click)="clearIncidentCounty()" *ngIf="data.County">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>City *</mat-label>
              <input type="text" matInput [(ngModel)]="data.Inc_City" [matAutocomplete]="nibinIncidentCityAutoComplete" name="nibinIncidentCityAutoComplete" [formControl]="CNTRL_INC_CITY">
              <mat-autocomplete #nibinIncidentCityAutoComplete="matAutocomplete" autoActiveFirstOption >
                <mat-option *ngFor="let c of FLTR_INC_CITY | async" [value]="c.City">
                  {{c.City}}
                </mat-option>
              </mat-autocomplete>

              <button mat-button mat-icon-button matSuffix (click)="clearIncidentCity()" *ngIf="data.Inc_City">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>


        </mat-grid-list>

        <mat-grid-list cols="5" rowHeight="100px">
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;" >
              <mat-label>Lab # *</mat-label>
              <input matInput [(ngModel)]="data.LabNumber" name="LabNumber" autocapitalize="characters" [matTooltip]="'Agency Case Number Or BRASSTRAX Case Number'">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;" >
              <mat-label>Case Number *</mat-label>
              <input matInput [(ngModel)]="data.CaseNumber" name="CaseNumber" autocapitalize="characters" [matTooltip]="'Original Agency Case Number Or BRASSTRAX Original Agency Reference Number'">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>Date of Occurrence: *</mat-label>
               <input matInput [matDatepicker]="OccurrenceDatePicker" [(ngModel)]="data.OccurrenceDate" name="DTOFOCC">
               <mat-datepicker-toggle matSuffix [for]="OccurrenceDatePicker"></mat-datepicker-toggle>
               <mat-datepicker #OccurrenceDatePicker></mat-datepicker>
           </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>Time of Occurrence: (HH:MM)</mat-label>
              <input matInput [(ngModel)]="data.OccurrenceTime" mask="Hh:m0" [leadZeroDateTime]="true" name="IncTimeOfOccurrence" [matTooltip]="'Time Format HH:MM'">

<!--              <mat-select [(value)]="data.OccurrenceTime">-->
<!--                <mat-option *ngFor="let hour of HoursList" [value]="hour">-->
<!--                  {{hour}}-->
<!--                </mat-option>-->
<!--              </mat-select>-->
<!--              <button mat-button mat-icon-button matSuffix (click)="clearIncidentTime()" *ngIf="data.OccurrenceTime">-->
<!--                <mat-icon>close</mat-icon>-->
<!--              </button>-->
            </mat-form-field>
          </mat-grid-tile>

<!--          <mat-grid-tile [colspan]="1" [rowspan]="1">-->
<!--            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">-->
<!--              <mat-label>Date of Submission: *</mat-label>-->
<!--              <input matInput [matDatepicker]="SubmissionDatePicker" [(ngModel)]="data.SubmissionDate" name="DTOFSUB">-->
<!--              <mat-datepicker-toggle matSuffix [for]="SubmissionDatePicker"></mat-datepicker-toggle>-->
<!--              <mat-datepicker #SubmissionDatePicker></mat-datepicker>-->

<!--            </mat-form-field>-->
<!--          </mat-grid-tile>-->

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>Location *</mat-label>
              <input matInput [(ngModel)]="data.Inc_Location" name="location" autocapitalize="characters">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="4" [rowspan]="1">
            <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
              <mat-label>Case Notes</mat-label>
              <input matInput [(ngModel)]="data.Notes" name="casenotes" style="width: 100%;">
            </mat-form-field>
          </mat-grid-tile>

        </mat-grid-list>

        <div>
          <button mat-button matStepperPrevious >Back</button>
          <!--matStepperNext-->
          <button mat-button  [disabled]="!validateStep3(false)" (click)="runNewAgencyCityCountyCheck(ModIncStepper)">Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [completed]="(validateNJPOPStep() && validateStepWeapons(false) && validateStep3(false))">
      <form>
        <ng-template matStepLabel>Weapon Details</ng-template>

        <button mat-button (click)="addWeaponRecord()" >+ Add Weapon</button>
        <mat-card *ngIf="!data.Weapon || data.Weapon.length<1">
          <h5>There are currently no Weapon Records in this Incident. Click
            <button mat-stroked-button (click)="addWeaponRecord()" >+ Add Weapon</button>
            to add a Weapon Record</h5>
        </mat-card>

        <mat-card *ngFor="let weapon of data.Weapon">
          <form>
            <mat-grid-list cols="8" rowHeight="75px">

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Make *</mat-label>
                  <input matInput [(ngModel)]="weapon.MAKE" name="Make" autocapitalize="characters">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>MODEL *</mat-label>
                  <input matInput [(ngModel)]="weapon.MODEL" name="MODEL" autocapitalize="characters">
                </mat-form-field>
              </mat-grid-tile>


              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Caliber *</mat-label>
                  <mat-select [(value)]="weapon.CALIBER">
                    <mat-option *ngFor="let ddlItem of ddls.Caliber" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                      {{ddlItem.DDL_Desc}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

<!--                <mat-form-field appearance="outline" style="width: 100%">-->
<!--                  <mat-label>Caliber *</mat-label>-->

<!--                  <input type="text" matInput [(ngModel)]="weapon.CALIBER" [matAutocomplete]="auto" [formControl]="CNTRL_WPN_CALIBER">-->
<!--                  <mat-autocomplete #auto="matAutocomplete" >-->
<!--                    <mat-option *ngFor="let c of  FLTR_WPN_CALIBER | async" [value]="c?.DDL_Desc">-->
<!--                      {{c?.DDL_Desc}}-->
<!--                    </mat-option>-->
<!--                  </mat-autocomplete>-->

<!--                  <button mat-button mat-icon-button matSuffix (click)="clearIncidentAgency()" *ngIf="data.Dept">-->
<!--                    <mat-icon>close</mat-icon>-->
<!--                  </button>-->
<!--                </mat-form-field>-->
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Classification *</mat-label>
                  <mat-select [(value)]="weapon.W_CLASS">
                    <mat-option *ngFor="let ddlItem of ddls.WeaponClassification" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                      {{ddlItem.DDL_Desc}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Serial</mat-label>
                  <input matInput [(ngModel)]="weapon.SERIAL_NUMBER" name="serial" autocapitalize="characters">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Evidence Marker</mat-label>
                  <input matInput [(ngModel)]="weapon.EvidenceMarker" name="marker" autocapitalize="characters">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Hit Ref #</mat-label>
                  <input matInput [(ngModel)]="weapon.PreviousHit" name="prevhit" autocapitalize="characters">
                </mat-form-field>
              </mat-grid-tile>


              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Date of Collection:</mat-label>
                  <input matInput [matDatepicker]="WPNDTOFCOLDatePicker" [(ngModel)]="weapon.DTOFCOLLECTION" name="DTOFCOL">
                  <mat-datepicker-toggle matSuffix [for]="WPNDTOFCOLDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #WPNDTOFCOLDatePicker></mat-datepicker>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Date of Submission:</mat-label>
                  <input matInput [matDatepicker]="WPNDTOFSUBDatePicker" [(ngModel)]="weapon.DTOFSUBMISSION" name="DTOFSUB">
                  <mat-datepicker-toggle matSuffix [for]="WPNDTOFSUBDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #WPNDTOFSUBDatePicker></mat-datepicker>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1" dense>
                <mat-checkbox [checked]="weapon.CT_Ghost_Gun" (change)="setWeaponCheck($event.checked, weapon)">
                  Ghost Gun
                </mat-checkbox>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1" dense>
                <mat-checkbox [checked]="weapon.SearModifyFlag" (change)="setSearModifyFlag($event.checked, weapon)">
                  Sear Modified
                </mat-checkbox>
              </mat-grid-tile>


              <mat-grid-tile [colspan]="7" [rowspan]="1" dense>
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Notes</mat-label>
                  <input matInput [(ngModel)]="weapon.Notes" name="notes" autocapitalize="characters">
                </mat-form-field>
              </mat-grid-tile>

            </mat-grid-list>




            <button mat-button (click)="deleteWeaponRecord(weapon)" style="color:red;">DELETE</button>
          </form>
        </mat-card>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext [disabled]="!validateStepWeapons(false)">Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [completed]="(validateNJPOPStep() && validateStepBallistics(false) && validateStep3(false))">
      <form>
        <ng-template matStepLabel>Ballistics Evidence Details</ng-template>

        <button mat-button (click)="addBallisticsRecord('Cartridge Case')">+ Add Cartridge Case</button>
        <button mat-button (click)="addBallisticsRecord('Projectile')">+ Add Projectile</button>

        <mat-card *ngIf="!data.Ballistics || data.Ballistics.length<1">
          <h5>There are currently no Ballistics Records in this Incident. Click
            <button mat-stroked-button (click)="addBallisticsRecord('Cartridge Case')">+ Add Cartridge Case</button>
            or
            <button mat-stroked-button (click)="addBallisticsRecord('Projectile')">+ Add Projectile</button>
            to add a Ballistics Record</h5>
        </mat-card>

        <mat-card *ngFor="let ballistic of data.Ballistics">
          <form *ngIf="ballistic.VGID_CPart?.toUpperCase() === 'Cartridge Case'.toUpperCase()">
            <mat-grid-list cols="7" rowHeight="75px">

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Qty</mat-label>
                  <input matInput [(ngModel)]="ballistic.Item_Quantity" name="Qty" mask="999">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Caliber</mat-label>
                  <mat-select [(value)]="ballistic.Caliber_Type">
                    <mat-option *ngFor="let ddlItem of ddls.Caliber" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                      {{ddlItem.DDL_Desc}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Marker(EVID/TFID)</mat-label>
                  <input matInput [(ngModel)]="ballistic.EvidenceMarker" name="Marker" autocapitalize="characters">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Hit Ref #</mat-label>
                  <input matInput [(ngModel)]="ballistic.PreviousHit" name="PrevHit" autocapitalize="characters">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Notes</mat-label>
                  <input matInput [(ngModel)]="ballistic.Notes" name="Notes" >
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Date of Collection:</mat-label>
                  <input matInput [matDatepicker]="BALDTOFCOLDatePicker" [(ngModel)]="ballistic.DTOFCOLLECTION" name="BALDTOFCOL">
                  <mat-datepicker-toggle matSuffix [for]="BALDTOFCOLDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #BALDTOFCOLDatePicker></mat-datepicker>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Date of Submission:</mat-label>
                  <input matInput [matDatepicker]="BALDTOFSUBDatePicker" [(ngModel)]="ballistic.DTOFSUBMISSION" name="BALDTOFSUB">
                  <mat-datepicker-toggle matSuffix [for]="BALDTOFSUBDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #BALDTOFSUBDatePicker></mat-datepicker>
                </mat-form-field>
              </mat-grid-tile>

            </mat-grid-list>
          </form>

          <form *ngIf="ballistic.VGID_CPart?.toUpperCase() === 'Projectile'.toUpperCase()">
            <mat-grid-list cols="7" rowHeight="75px">

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Qty</mat-label>
                  <input matInput [(ngModel)]="ballistic.Item_Quantity" name="Qty" mask="999">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Caliber</mat-label>
                  <mat-select [(value)]="ballistic.Caliber_Type">
                    <mat-option *ngFor="let ddlItem of ddls.Caliber" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                      {{ddlItem.DDL_Desc}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>CL-L&G</mat-label>
                  <mat-select [(value)]="ballistic.CL_LG">
                    <mat-option [value]="'1'" >1</mat-option>
                    <mat-option [value]="'2'" >2</mat-option>
                    <mat-option [value]="'3'" >3</mat-option>
                    <mat-option [value]="'4'" >4</mat-option>
                    <mat-option [value]="'5'" >5</mat-option>
                    <mat-option [value]="'6'" >6</mat-option>
                    <mat-option [value]="'7'" >7</mat-option>
                    <mat-option [value]="'8'" >8</mat-option>
                    <mat-option [value]="'9'" >9</mat-option>
                    <mat-option [value]="'10'" >10</mat-option>
                    <mat-option [value]="'11'" >11</mat-option>
                    <mat-option [value]="'12'" >12</mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>CL-Twist</mat-label>
                  <mat-select [(value)]="ballistic.CL_Twist">
                    <mat-option [value]="'LEFT'" >Left</mat-option>
                    <mat-option [value]="'RIGHT'" >Right</mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>CL-Type</mat-label>
                  <mat-select [(value)]="ballistic.CL_Type">
                    <mat-option [value]="'CONVENTIONAL'" >Conventional</mat-option>
                    <mat-option [value]="'POLY'" >Poly</mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Marker(EVID/TFID)</mat-label>
                  <input matInput [(ngModel)]="ballistic.EvidenceMarker" name="Marker">
                </mat-form-field>
              </mat-grid-tile>



              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Notes</mat-label>
                  <input matInput [(ngModel)]="ballistic.Notes" name="Notes">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Date of Collection:</mat-label>
                  <input matInput [matDatepicker]="BALDTOFCOLDatePicker" [(ngModel)]="ballistic.DTOFCOLLECTION" name="BALDTOFCOL">
                  <mat-datepicker-toggle matSuffix [for]="BALDTOFCOLDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #BALDTOFCOLDatePicker></mat-datepicker>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Date of Submission:</mat-label>
                  <input matInput [matDatepicker]="BALDTOFSUBDatePicker" [(ngModel)]="ballistic.DTOFSUBMISSION" name="BALDTOFSUB">
                  <mat-datepicker-toggle matSuffix [for]="BALDTOFSUBDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #BALDTOFSUBDatePicker></mat-datepicker>
                </mat-form-field>
              </mat-grid-tile>

            </mat-grid-list>
          </form>
          <button mat-button (click)="deleteBallisticsRecord(ballistic)" style="color:red;">DELETE</button>
        </mat-card>

        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext [disabled]="!validateStepBallistics(false)">Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [completed]="(validateNJPOPStep() && validateStepBallistics(false) && validateStepWeapons(false) && validateStep3(false))">
      <ng-template matStepLabel>People & Save</ng-template>
      <form>
        <button mat-button (click)="addPersonRecord()" >+ Add Person</button>
        <mat-card *ngIf="!data.Persons || data.Persons.length<1">
          <h5>There are currently no Person Records in this Incident. Click
            <button mat-stroked-button (click)="addPersonRecord()" >+ Add Person</button>
            to add a Person Record</h5>
        </mat-card>

        <mat-card *ngFor="let person of data.Persons" style="margin-top:5px">
          <form>
            <mat-grid-list cols="12" rowHeight="75px">

              <mat-grid-tile [colspan]="2" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Role</mat-label>
                  <mat-select [(value)]="person.Role">
                    <mat-option value="INVESTIGATOR">
                      INVESTIGATOR
                    </mat-option>

                    <mat-option value="OTHER">
                      OTHER
                    </mat-option>

                    <mat-option value="SUSPECT">
                      SUSPECT
                    </mat-option>

                    <mat-option value="SUSPECT/VICTIM">
                      SUSPECT/VICTIM
                    </mat-option>

                    <mat-option value="VICTIM">
                      VICTIM
                    </mat-option>

                    <mat-option value="WITNESS">
                      WITNESS
                    </mat-option>

                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="2" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>First Name</mat-label>
                  <input matInput [(ngModel)]="person.FIRSTNAME"  [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>MI</mat-label>
                  <input matInput [(ngModel)]="person.MI"  [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="2" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Last Name</mat-label>
                  <input matInput [(ngModel)]="person.LASTNAME" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="2" [rowspan]="1">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Suffix</mat-label>
                  <input matInput [(ngModel)]="person.Suffix" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </mat-grid-tile>


              <mat-grid-tile [colspan]="2" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() !== 'Investigator'.toUpperCase()">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>SBI</mat-label>
                  <input matInput [(ngModel)]="person.SBINo" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </mat-grid-tile>


              <mat-grid-tile [colspan]="2" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() !== 'Investigator'.toUpperCase()">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>FBI</mat-label>
                  <input matInput [(ngModel)]="person.FBI" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="2" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() === 'Investigator'.toUpperCase()">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Email</mat-label>
                  <input matInput [(ngModel)]="person.Email" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="2" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() === 'Investigator'.toUpperCase()">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Rank</mat-label>
                  <input matInput [(ngModel)]="person.Rank"  [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="2" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() === 'Investigator'.toUpperCase()">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Phone</mat-label>
                  <input matInput [(ngModel)]="person.Phone" [ngModelOptions]="{standalone: true}" mask="(000) 000-0000">
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile [colspan]="2" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() !== 'Investigator'.toUpperCase()">
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>DOB</mat-label>

                  <input matInput [matDatepicker]="PDOBDatePicker" [(ngModel)]="person.DOB" name="PDOB">
                  <mat-datepicker-toggle matSuffix [for]="PDOBDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #PDOBDatePicker></mat-datepicker>
                </mat-form-field>
              </mat-grid-tile>


              <mat-grid-tile [colspan]="12" [rowspan]="1" dense>
                <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
                  <mat-label>Notes</mat-label>
                  <input matInput [(ngModel)]="person.AdditionalNotes" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </mat-grid-tile>

            </mat-grid-list>

            <button mat-button (click)="deletePersonRecord(person)" style="color:red;">DELETE</button>
          </form>
        </mat-card>
      </form>
      <div >
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button (click)="saveIncident()">Save Incident</button>
      </div>
    </mat-step>
  </mat-stepper>
</div>
